import { FirestoreConverter } from '../../converter';
import { ScreenConverter } from '../../screen/ScreenConverter';
import { Mode } from '../mode';
import { Client } from '../Client';
import { pauseFromFirestore } from '../pause';
import { trialGoalFromFirestore } from '../trialGoal';

/**
 * The converter instance from / to player instance
 */
export const ClientConverter: FirestoreConverter<Client> = {
    fromFirestore: (snapshot: any, options: any): Client => {
        const data = snapshot.data(options);
        const screens = Object.fromEntries(
            Object.entries(data.screenInfos).map(([key, value]) => [
                key,
                ScreenConverter.fromFirestore({ ...(value as any), id: key }),
            ])
        );

        return Object.assign(new Client(), {
            _id: data.id,
            _mode: data.mode || Mode.Anim,
            _lang: data.lang || 'en',
            _name: data.name,
            _games: data.games,
            _instanceIDs: data.instances,
            _screens: screens,
            _stripeCustomerId: data.stripeCustomerId,
            _stripeSubscriptionId: data.stripeSubscriptionId,
            _disabled: data.disabled || false,
            _freePlayEnabled: data.freePlayEnabled || false,
            _socketServer: data.socketServer,
            // Tri-state volontaire : PAS de `|| false` — un client historique
            // (champ absent) ne doit JAMAIS voir le tutoriel d'onboarding.
            _onboardingCompleted: data.onboardingCompleted,
            _pause: pauseFromFirestore(data.pause),
            // Lecture seule (écrit par le serveur) : volontairement absent de toFirestore.
            _trialGoal: trialGoalFromFirestore(data.trialGoal),
            // Idem (stripe-b2b) : verrouillé par les règles Firestore.
            _plan: data.plan === 'pro' ? 'pro' : undefined,
        });
    },
    toFirestore: (client: Client): any => ({
        id: client.id,
        name: client.name,
        games: client.gameIDs,
        screens: client._screens,
    }),
};
